import { formatInTimeZone } from 'date-fns-tz';

export const getEventHours = (
  timeZone: string,
  beginAt: string,
  endAt?: string
): string => {
  const formattedBegin = formatInTimeZone(beginAt, timeZone, 'h:mmaaa');
  const formattedTimezone = formatInTimeZone(beginAt, timeZone, 'zzz');

  if (!endAt) {
    return `${formattedBegin} ${formattedTimezone}`;
  }
  const formattedEnd = formatInTimeZone(endAt, timeZone, 'h:mmaaa');
  return `${formattedBegin}–${formattedEnd} ${formattedTimezone}`;
};
